// extracted by mini-css-extract-plugin
export default {"brandContainer":"styles_brandContainer__V23lj","logoContainer":"styles_logoContainer__MB86t","logo":"styles_logo__EVeBU","toggleButton":"styles_toggleButton__+yIsN"};